<template>
    <div id="permission">
        <div class="tree-panel">
            <div class="tree-header">
                <div>
                    <el-button type="default" size="mini" @click="$router.back()">返回</el-button>
                </div>
                <div>
                    <el-input size="mini" class="search-input " placeholder="应用名称"
                              v-model="treeSearchText" @keyup.enter.native="filterTreeHandler">
                        <el-button slot="append" icon="el-icon-search" size="mini"
                                   @click="filterTreeHandler"></el-button>
                    </el-input>
                </div>
            </div>
            <div class="tree-container" :style="{height: `${windowHeight - 190}px`}">
                <el-tree class="filter-tree"
                         highlight-current
                         ref="tree"
                         draggable
                         :data="treeData"
                         :props="defaultProps"
                         :filter-node-method="filterNode"
                         node-key="id"
                         :expand-on-click-node='false'
                         @node-click="nodeClickHandler"
                         :default-expanded-keys="defaultExpandedArray">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span :title="data.name">{{ data.name }}</span>
                    </span>
                </el-tree>
            </div>

        </div>
        <div class="main-panel" :style="{width: `${windowWidth - 580}px`}">
            <div>
                <div class="info-line" v-show="permissionDetail.name">
                    <span class="info-line__name">{{permissionDetail.name}}</span>
                    <span>菜单路径：<span class="info-line__value">{{permissionDetail.url}}</span></span>
                    <span>网页显示名称：<span class="info-line__value">{{permissionDetail.description}}</span></span>
                    <span>应用名称：<span class="info-line__value">{{permissionDetail.name}}</span></span>
                </div>
                <div class="header-line">
                      <el-input style="width: 240px" class="search-input search-input--right"
                              size="medium"
                              placeholder="资源名称或资源路径" icon="el-icon-search"
                              v-model.trim="resourceName">
                        <el-button slot="append" size="medium" icon="el-icon-search"></el-button>
                    </el-input>
                </div>
                <el-table
                    :height="windowHeight - 270"
                    :data="dataList"
                    style="width: 100%" border
                >
                    <el-table-column
                        label="id"
                        prop="id"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        label="资源名"
                        align="center"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.name }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="页面显示名称"
                        align="center"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.description }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="资源路径"
                        prop="url"
                        align="center"
                        width="240px"
                    >
                    </el-table-column>
                    <el-table-column
                        label="资源属性"
                        align="center"
                    >
                        <template slot-scope="scope">
                            {{ ['菜单', '功能', '应用文件夹'][scope.row.type] }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="资源类型"
                        align="center"
                    >
                        <template slot-scope="scope">
                            {{ {
                            1: 'pc',
                            2: '移动端',
                            3: '公共',
                            }[scope.row.label] }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <el-button type="text" @click="editPermission(scope.row)">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <el-dialog title="编辑" :visible.sync="isShowEditPermissionDialog" :close-on-press-escape='false'
                   width="600px"
                   :lock-scroll="false"
                   :close-on-click-modal='false' :modal-append-to-body='false'>
            <div class="dialog-form">
                <el-form ref="editPermissionForm" :model="editPermissionForm" :rules="permissionFormRules"
                         label-width="120px">
                    <el-form-item label="名称">
                        {{editPermissionForm.name}}
                    </el-form-item>
                    <el-form-item label="路径">
                        {{editPermissionForm.url}}
                    </el-form-item>
                    <el-form-item label="终端类型">
                        {{['', 'PC端', '移动端', '公共'][editPermissionForm.label]}}
                    </el-form-item>
                    <el-form-item label="资源属性">
                        {{['菜单', '功能', '应用文件夹'][currentType]}}
                    </el-form-item>
                    <el-form-item label="页面显示名称" prop="description">
                        <el-input v-model.trim="editPermissionForm.description" style="width: 400px;"></el-input>
                    </el-form-item>
                    <el-form-item label="应用模块">
                        {{editPermissionForm.moduleName}}
                    </el-form-item>
                    <el-form-item label="上级菜单">
                        {{currentNode ? currentNode.name : ''}}
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="isShowEditPermissionDialog = false">取 消</el-button>
                <el-button size="medium" type="primary" @click="editPermissionConfirm">确定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import windowResize from '@/mixins/windowResize.js';
    import baseMixin from '@/mixins/baseMixin.js';

    import {isShowByPermission} from "@/utils/utils";
    import {
        queryModuleByModel,
        querySysMenuType
    } from '@/api/permission';
    import {
        permissTree,
        listPermByPid,
        getpermiss,
        schooPermissionManagerUpdate
    } from '@/api/schoolPermission';
    export default {
        name: 'schoolPermission',
        mixins: [windowResize, baseMixin],
        data() {
            return {
                schoolId: this.$route.query.schoolId,
                treeData: [],
                treeSearchText: '',
                isShowEditPermissionDialog: false,
                defaultProps: {
                    children: 'childrens',
                    label: 'label'
                },
                currentType: 0,
                currentNode: null,
                defaultExpandedArray: [0],
                editExpandArray: [],
                moduleAppList: [],
                permissionDetail: {
                    name: '',
                    label: '',
                    url: '',
                    sort: '',
                    description: '',
                    hidden: 2,
                    moduleName: '',
                    systemType: '',

                },

                permissionFormRules: {
                    description: [{
                        required: true, message: '请填写页面显示名称', trigger: 'blur'
                    }],
                },
                systemTypeList: [],

                editPermissionForm: {
                    description: '',
                    label: '',
                    moduleId: '',
                    name: '',
                    systemType: '',
                    url: '',
                    pid: '',
                    moduleName: ''
                },
                resourceName: '',
                resourceList: [],
                roleList: [],
                roleResourceName: ''
            }
        },
        created() {
            this.permissTreeFunc();
            querySysMenuType()
                .then(data => {
                    this.systemTypeList = data;
                })
        },
        computed: {
            dataList() {
                return this.resourceList.filter(item => item.name.includes(this.resourceName) || item.url.includes(this.resourceName))
            }
        },
        methods: {
            isShowByPermission,
            filterTreeHandler() {
                this.treeSearchText = this.treeSearchText.trim();
                this.$refs.tree.filter();
            },
            listPermByPidFunc() {
                listPermByPid({
                    pid: this.currentNode ? this.currentNode.id : 0,
                    schoolId: this.$route.query.schoolId
                })
                    .then(data => {
                        this.resourceList = data;
                    })
            },
            permissTreeFunc() {
                permissTree({
                    schoolId: this.schoolId
                })
                    .then(data => {
                        this.treeData = [data];
                    })
            },
            filterNode(value, data) {
                return `${data.t}`.includes(this.treeSearchText) || data.name.includes(this.treeSearchText)
            },

            nodeClickHandler(node) {
                this.resourceName = '';
                this.currentNode = node;
                let pNode = this.$refs.tree.getNode(this.currentNode.id);
                const parentIdList = [];
                while (!!pNode.parent) {
                    if(node.level != 0) {
                        parentIdList.unshift(pNode.data.id);
                    }
                    pNode = pNode.parent;
                }
                parentIdList.unshift(0);
                this.defaultExpandedArray = parentIdList;
                getpermiss({
                    id: node.id,
                    schoolId: this.schoolId
                })
                    .then(data => {
                        this.permissionDetail = data || {
                            name: '',
                            label: '',
                            url: '',
                            sort: '',
                            description: '',
                            hidden: 2,
                            moduleName: '',
                            systemType: '',
                        };
                    });
                this.listPermByPidFunc();

            },
            editNodeClickHandler(node) {
                this.editPermissionForm.pid = node.id;
            },

            editPermission(menuNode = null) {
                console.log('menuNode', menuNode);
                this.currentType = menuNode.type;

                this.editPermissionForm = JSON.parse(JSON.stringify(menuNode));
                this.editPermissionForm.id = menuNode.id;
                this.editPermissionForm.pid = menuNode.pid;

                let node = this.$refs.tree.getNode(menuNode ? menuNode.pid : this.currentNode.pId);

                const parentIdList = [];
                if(menuNode) {
                    parentIdList.unshift(node.data.id);
                }
                while (!!node.parent) {
                    node = node.parent;
                    if(node.level != 0) {
                        parentIdList.unshift(node.data.id);
                    }
                }
                parentIdList.unshift(0);
                this.editExpandArray = parentIdList;
                queryModuleByModel()
                    .then(data => {
                        // this.editPermissionForm.moduleName =
                        const moduleObj = data.find(item => item.id == this.editPermissionForm.moduleId);
                        this.editPermissionForm.moduleName = moduleObj ? moduleObj.name : '';
                        this.isShowEditPermissionDialog = true;
                    });
            },
            editPermissionConfirm() {
                this.$refs.editPermissionForm.validate(isValid => {
                    if (isValid) {
                        schooPermissionManagerUpdate({
                            permissionId: this.editPermissionForm.id,
                            schoolId: this.schoolId,
                            description: this.editPermissionForm.description
                        })
                            .then(() => {
                                this.$message.success('编辑成功');
                                this.isShowEditPermissionDialog = false;
                                this.permissTreeFunc();
                                this.listPermByPidFunc();
                            });
                    }
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/mixin";

    #permission {
        height: 100%;
    }

    .tree-header {
        padding: 12px;
        top: 0;

        & > div:first-of-type {
            margin-bottom: 12px;
        }
    }

    .tree-header--placeholder {
        height: 94px;
    }

    .tree-container {
        height: 300px;
        overflow-y: auto;
        @include scrollBar;
        width: 260px;

    }

    .tree-panel {
        position: relative;
        float: left;
        width: 260px;
        border-right: 1px solid #f1f1f1;
    }

    .main-panel {
        float: left;
        padding: 12px;
    }

    .title {
        margin: 10px 0;
        border-left: 4px solid #409EFF;
        padding-left: 12px;
        height: 16px;
        line-height: 16px;
    }

    .line {
        margin: 20px 0;

        .label, .value {
            display: inline-block;
            vertical-align: top;
        }

        .label {
            width: 7em;
            margin-right: 10px;
            text-align: right;
        }

        .value {
            word-break: break-all;
            line-height: 21px;
        }

    }
    .resource-name {
        color: #409EFF;
        cursor: pointer;
    }
    .role-list {
        margin-top: 30px;
        @include clearfix;
        .role-item {
            float: left;
            margin-right: 10px;
        }
    }
    .title--large {
        margin: 30px 0;
    }
    .info-line {
        color: #606266;
        margin-bottom: 10px;
        .info-line__name {
            font-size: 24px;
            margin-right: 24px;
        }
        .info-line__value {
            color: #409EFF;
            margin-right: 24px;
        }
    }
    .header-line {
        padding-bottom:10px;
        @include clearfix;
    }
</style>
<style lang="scss">
    .dialog-form .is-current.is-focusable > .el-tree-node__content {
        background-color: #20a0ff !important;
        color: #fff !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/schoolManage/schoolPermission.vue